import summaryApi from "../common/index";
import { toast } from "react-hot-toast";

const addToCart = async (e, id) => {
  e?.stopPropagation();
  e?.preventDefault();

  try {
    console.log("Sending fetch request:", { productId: id });

    const response = await fetch(summaryApi.addToCartProduct.url, {
      method: summaryApi.addToCartProduct.method,
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ productId: id }), // ✅ removed size
    });

    const responseData = await response.json();

    if (response.ok && responseData.success) {
      toast.success(responseData.message || "✅ Product added to cart!");
    } else {
      toast.error(responseData.message || "❌ Failed to add product to cart.");
    }

    return responseData;
  } catch (error) {
    toast.error("⚠️ Network error. Please try again.");
    return {
      success: false,
      message: "Network error. Please check your connection and try again.",
    };
  }
};

export default addToCart;
